export const normalizeTrackingId = (value?: string | null): string | null => value?.trim() || null

export const appendTrackingScript = (id: string, src: string, parent: HTMLElement, innerHtml?: string): void => {
  if (document.getElementById(id)) {
    return
  }

  const script = document.createElement("script")
  script.id = id

  if (innerHtml) {
    script.innerHTML = innerHtml
  } else {
    script.async = true
    script.src = src
  }

  parent.appendChild(script)
}
